import React from "react";
import classes from "./TextInput.module.css";
import { useState } from "react";
import { useTranslation } from "../../../I18n/Languages/LanguageContext";

const CustomTextInput = ({
  name,
  value,
  onChange,
  onBlur,
  type = "text",
  label,
  topLabel,
  placeholder,
  icon,
  iconPosition = "end",
  error,
  helperText,
  disabled,
  readOnly = false,
  width,
  isNumber = false,
  maxLength,
}) => {
  const { t } = useTranslation();
  const [localError, setLocalError] = useState("");

  return (
    <div className={classes.inputWrapper}>
      {topLabel && (() => {
  const match = topLabel.match(/^(.*?)\s*\((.*?)\)$/);
  if (match) {
    const [_, mainText, parenText] = match;
    return (
      <label className={classes.topLabel}>
        {mainText}{" "}
        <span className={classes.topLabelParen}>({parenText})</span>
      </label>
    );
  }
  return <label className={classes.topLabel}>{topLabel}</label>;
})()}


      <div
        className={`${classes.inputContainer} ${error ? classes.error : ""} ${
          disabled ? classes.disabled : ""
        }`}
        style={{ width }}
      >
        {icon && iconPosition === "start" && (
          <span className={classes.icon}>{icon}</span>
        )}

        <input
          type={type}
          name={name}
          value={value}
          onChange={(e) => {
            let newValue = e.target.value;

            if (isNumber) {
              const invalidChars = /[^0-9]/g.test(newValue);
              if (invalidChars) {
                setLocalError(t('only_numbers_allowed'));
              } else {
                setLocalError("");
              }

              newValue = newValue.replace(/[^0-9]/g, "");
            }

            if (maxLength && newValue.length > maxLength) {
              setLocalError(t("max_length_error", { count: maxLength }));
            } else if (!isNumber || !/[^0-9]/g.test(newValue)) {
              // pastro error nëse nuk ka shkelje
              setLocalError("");
            }

            onChange?.({ ...e, target: { ...e.target, value: newValue } });
          }}
          onBlur={onBlur}
          placeholder={placeholder || label}
          disabled={disabled}
          readOnly={readOnly}
          className={classes.input}
          autoComplete="off"
          inputMode={isNumber ? "numeric" : "text"}
          maxLength={maxLength}
        />

        {icon && iconPosition === "end" && (
          <span className={classes.icon}>{icon}</span>
        )}
      </div>
      {(localError || helperText) && (
  <div className={`${classes.helperText} ${error || localError ? classes.error : ""}`}>
    {localError || helperText}
  </div>
)}
    </div>
  );
};

export default CustomTextInput;
